import React from 'react';

import Close from '@material-ui/icons/Close';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';

import { makeStyles } from '@material-ui/styles';
import styles from './styles';
import { injectIntl } from 'react-intl';
const useStyles = makeStyles(styles);

export function GenericDrawer(props) {
    const classes = useStyles();

    const { open = false, title = '', children, onClose } = props;

    const handleClose = () => {
        !!onClose && onClose();
    };

    return (
        <Drawer anchor="right" open={open} onClose={handleClose}>
            <div className={classes.header}>
                <Typography variant="h5">{title}</Typography>
                <IconButton className={classes.closeButton} onClick={handleClose}>
                    <Close />
                </IconButton>
            </div>
            <div className={classes.content}>{open && children}</div>
        </Drawer>
    );
}

export default injectIntl(GenericDrawer);
